import { render, staticRenderFns } from "./OrderBoxSell.vue?vue&type=template&id=8f92a642&scoped=true"
import script from "./OrderBoxSell.vue?vue&type=script&lang=js"
export * from "./OrderBoxSell.vue?vue&type=script&lang=js"
import style0 from "./OrderBoxSell.vue?vue&type=style&index=0&id=8f92a642&prod&lang=scss&scoped=true"
import style1 from "./OrderBoxSell.vue?vue&type=style&index=1&id=8f92a642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f92a642",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrderBoxTabTitle: require('/drone/src/components/OrderBox/OrderBoxTabTitle.vue').default,WxFollowQr: require('/drone/src/components/WxFollowQr.vue').default,PZTabs: require('/drone/src/components/PZTabs/index.vue').default,OrderBoxSellGoods: require('/drone/src/components/OrderBox/OrderBoxSellGoods.vue').default,PzImage: require('/drone/src/components/PzImage/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default,GoodsListPage: require('/drone/src/components/GoodsListPage/index.vue').default})
